<div class="domain-import-configure">
    <div class="mb-4">
        <h5 translate>Import Options</h5>
        <p class="text-muted" translate>
            Configure which domain components to import. You can skip certain elements if they're not needed or if you want to configure them manually later.
        </p>
    </div>

    <div class="configuration-options">
        <!-- Skip Domain Groups -->
        <div class="option-card">
            <div class="option-header">
                <div class="option-icon">
                    <i [class]="getOptionIcon('skipDomainGroups')"></i>
                </div>
                <div class="option-info">
                    <h6 class="option-title">{{ getOptionLabel('skipDomainGroups') }}</h6>
                    <p class="option-description">{{ getOptionDescription('skipDomainGroups') }}</p>
                </div>
                <div class="option-toggle">
                    <div class="form-check form-switch">
                        <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="skipDomainGroups"
                            [checked]="localConfig.skipDomainGroups"
                            (change)="updateConfiguration('skipDomainGroups', $event.target.checked)">
                        <label class="form-check-label" for="skipDomainGroups">
                            <span class="switch-label" translate>
                                {{ localConfig.skipDomainGroups ? 'Skip' : 'Include' }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Skip Path Constraints -->
        <div class="option-card">
            <div class="option-header">
                <div class="option-icon">
                    <i [class]="getOptionIcon('skipPathConstraints')"></i>
                </div>
                <div class="option-info">
                    <h6 class="option-title">{{ getOptionLabel('skipPathConstraints') }}</h6>
                    <p class="option-description">{{ getOptionDescription('skipPathConstraints') }}</p>
                </div>
                <div class="option-toggle">
                    <div class="form-check form-switch">
                        <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="skipPathConstraints"
                            [checked]="localConfig.skipPathConstraints"
                            (change)="updateConfiguration('skipPathConstraints', $event.target.checked)">
                        <label class="form-check-label" for="skipPathConstraints">
                            <span class="switch-label" translate>
                                {{ localConfig.skipPathConstraints ? 'Skip' : 'Include' }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Skip Link Excludes -->
        <div class="option-card">
            <div class="option-header">
                <div class="option-icon">
                    <i [class]="getOptionIcon('skipLinkExcludes')"></i>
                </div>
                <div class="option-info">
                    <h6 class="option-title">{{ getOptionLabel('skipLinkExcludes') }}</h6>
                    <p class="option-description">{{ getOptionDescription('skipLinkExcludes') }}</p>
                </div>
                <div class="option-toggle">
                    <div class="form-check form-switch">
                        <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="skipLinkExcludes"
                            [checked]="localConfig.skipLinkExcludes"
                            (change)="updateConfiguration('skipLinkExcludes', $event.target.checked)">
                        <label class="form-check-label" for="skipLinkExcludes">
                            <span class="switch-label" translate>
                                {{ localConfig.skipLinkExcludes ? 'Skip' : 'Include' }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Summary -->
    <div class="import-summary mt-4">
        <h6 translate>Import Summary</h6>
        <div class="summary-items">
            <div class="summary-item" [class.text-muted]="localConfig.skipDomainGroups">
                <i class="fas fa-layer-group me-2"></i>
                <span>Domain Groups: {{ localConfig.skipDomainGroups ? 'Skipped' : 'Included' }}</span>
            </div>
            <div class="summary-item" [class.text-muted]="localConfig.skipPathConstraints">
                <i class="fas fa-route me-2"></i>
                <span>Path Constraints: {{ localConfig.skipPathConstraints ? 'Skipped' : 'Included' }}</span>
            </div>
            <div class="summary-item" [class.text-muted]="localConfig.skipLinkExcludes">
                <i class="fas fa-ban me-2"></i>
                <span>Link Excludes: {{ localConfig.skipLinkExcludes ? 'Skipped' : 'Included' }}</span>
            </div>
        </div>
    </div>
</div>
